<template>
  <div>
    <v-form @submit="onSubmit">
      <b-form-group id="input-group-1" label="Project" label-for="input-1">
        <b-form-select :options="projects" v-model="form.project" required>
        </b-form-select>
      </b-form-group>
      <p v-if="feedbackProject" class="feedback_text">{{ feedbackProject }}</p>
      <b-form-group
        id="input-group-member"
        label="Member"
        label-for="input-member"
      >
        <b-form-select :options="teams" v-model="form.user" required>
        </b-form-select>
      </b-form-group>
      <p v-if="feedbackTeams" class="feedback_text">{{ feedbackTeams }}</p>
      <b-form-group
        id="input-group-2"
        label="Task Description"
        label-for="input-2"
      >
        <b-form-textarea
          v-model="form.description"
          placeholder="Enter Description"
          type="Text"
        >
        </b-form-textarea>
      </b-form-group>
      <b-form-group id="input-group-3" label="Date" label-for="input-3">
        <b-form-datepicker
          reset-button
          reset-button-variant
          id="timesheet-datepicker"
          v-model="form.date"
          class="mb-2"
          required
          left
        ></b-form-datepicker>
      </b-form-group>
      <p v-if="feedbackDate" class="feedback_text">{{ feedbackDate }}</p>
      <b-form-group
        id="input-group-4"
        label="Hours [00:00]"
        label-for="input-4"
      >
        <b-form-input
          v-model="form.hours"
          class="mb-2"
          @change="onChangeHours"
          pattern="[0-9!:.]{0,5}"
          placeholder="Enter time in either minutes or h:m format. E.g. 90 for 1 hour and 30 mins, or 3: for 3 hours"
          required
        ></b-form-input>
      </b-form-group>
      <p v-if="feedbackHours" class="feedback_text">{{ feedbackHours }}</p>
      <b-button type="submit" variant="success" :disabled="disableSubmitBtn"
        >Submit</b-button
      >
      <b-button variant="secondary" @click="closeModal($event.target)"
        >Cancel</b-button
      >
    </v-form>
  </div>
</template>
<script>
import {mapGetters, mapActions} from "vuex";
import {convertHMSFormatInputToHours, HHMMFormat} from "@/Utilites/timerHelper";

import {strIs} from "@/Utilites/helper";
export default {
  name: "CreateTimeSheetForm",
  props: ["modalId", "project", "member"],
  data() {
    return {
      form: {
        project: null,
        user: null,
        description: "",
        hours: "",
        date: "",
      },
      feedbackProject: null,
      feedbackTeams: null,
      feedbackDate: null,
      feedbackHours: null,
      disableSubmitBtn: false,
      projects: [{value: null, text: "---Choose-Project---"}],
      teams: [{value: null, text: "---Choose-Member---"}],
    };
  },
  computed: {
    ...mapGetters(["getProjectNameList", "userProfileData", "getTeamNameList"]),
  },
  mounted() {
    this.projects.push(...this.project);
    this.teams.push(...this.member);
  },
  methods: {
    ...mapActions(["addNewTimeSheet", "showLoadingProcess", "closeLoading"]),
    onChangeHours(value) {
      this.form.hours = HHMMFormat(value);
    },
    checkInfo() {
      const error = "This cannot be empty";
      this.feedbackProject = strIs(this.form.project) ? null : error;
      this.feedbackTeams = strIs(this.form.user) ? null : error;
      this.feedbackDate = strIs(this.form.date) ? null : error;
      this.feedbackHours = strIs(this.form.hours) ? null : error;

      return (
        !this.feedbackProject &&
        !this.feedbackTeams &&
        !this.feedbackDate &&
        !this.feedbackHours
      );
    },

    async onSubmit(evt) {
      this.disableSubmitBtn = true;
      if (this.checkInfo()) {
        evt.preventDefault();
        await this.showLoadingProcess();
        try {
          this.form.hours = convertHMSFormatInputToHours(this.form.hours);
          await this.addNewTimeSheet(this.form);
          this.$emit("create-timesheet");
          this.closeModal();
          await this.closeLoading();
        } catch (err) {
          console.log("Error" + JSON.stringify(err));
          await this.closeLoading();
        }
      } else {
        console.log("Empty fields");
      }
      this.disableSubmitBtn = false;
    },
    closeModal() {
      this.$bvModal.hide(this.modalId);
    },
  },
};
</script>

<style scoped>
.feedback_text {
  color: red;
}
</style>
